import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SearchAutoComplete } from 'components/index.js'
import AnimatedNavbar from './components/AnimatedNavbar/AnimatedNavbar'
import SettingDropdown from './components/SettingDropdown'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FaUser } from 'react-icons/fa'
import { creditModal, toggleAuthModal, updateSearchAction } from 'store/actions/header.action'
import { pages } from 'utils/constants'
import ThemeDropDown from '../../components/ThemeDropDown'
import { getModelsAction } from 'store/actions/models.action'

const MobileHeader = () => {
  const { t } = useTranslation('common')

  const router = useRouter()
  const { search } = router.query
  const dispatch = useDispatch()
  const { data: models, loading } = useSelector((state) => state.models)
  const { subscription, user } = useSelector((state) => state.auth)
  const { activeChatTheme } = useSelector((state) => state.theme)

  const [inputSearch, setInputSearch] = useState('')
  const [mobileMenu, setMobileMenu] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  useEffect(() => {
    if (!models && !loading) dispatch(getModelsAction())
  }, [])

  useEffect(() => {
    dispatch(updateSearchAction(null, true))
  }, [router.pathname])

  useEffect(() => {
    setInputSearch(search)
  }, [search])

  const handleSearch = (value, select = true) => {
    setInputSearch(value)
    if (value?.trim() && select) {
      dispatch(updateSearchAction(value))
      router.push(`/model/${value}`)
    } else if (value?.trim() && !select) {
      dispatch(updateSearchAction(value))
      router.push(`/search?search=${value}`)
    }
  }

  const handleSubmit = (e, value) => {
    e.preventDefault()
    handleSearch(value, false)
  }

  const formatSearchResult = (item) => {
    return (
      <div className="flex flex-col cursor-pointer">
        <span className="text-sm font-bold">{item.name}</span>
        <span className="text-xs opacity-50 whitespace-wrap">{item.description}</span>
      </div>
    )
  }

  const handleSearchOpen = () => {
    setIsSearchOpen((prev) => !prev)
  }

  return (
    <>
      <div
        className={`header flex items-center justify-between left-0 top-[33px] bg-white z-[998] pt-[3px] pb-1.5 w-full h-[56px]  ${activeChatTheme != 'theme5' ? '!bg-black' : ''} px-6 capitalize`}
      >
        <div className={`flex gap-3 justify-start header-left relative ps-8 ${isSearchOpen ? '!w-full' : '!w-1/3'} `}>
          <div
            className={`w-10 h-10 flex items-center rounded-full border border-solid justify-center ${isSearchOpen ? 'border-neutral-300' : 'border-white'}`}
            onClick={() => handleSearchOpen()}
          >
            <img
              src={`/assets/common/${isSearchOpen ? 'close' : 'search_icon'}.svg`}
              alt={isSearchOpen ? 'close' : 'search'}
              className={`w-4 ${isSearchOpen ? 'fixed right-6 z-10' : 'w-6'}`}
            />
          </div>

          {isSearchOpen && (
            <div
              className={`searchbar-mobile flex-shrink-0 w-auto flex-grow z-[1] h-[44px] transition-all ease-in	duration-300`}
            >
              <form onSubmit={(e) => handleSubmit(e, inputSearch)}>
                <SearchAutoComplete
                  placeholder="search models or media"
                  items={models}
                  maxResults={12}
                  onSearch={setInputSearch}
                  onSelect={(item) => item && handleSearch(item.alias)}
                  autoFocus
                  formatResult={formatSearchResult}
                  classNames="!top-1 !fixed !w-[86%] !left-[12%]"
                />
              </form>
            </div>
          )}
        </div>
        <div className={`items-center gap-3  w-1/3 justify-center ${isSearchOpen ? 'hidden' : 'inline-flex'}`}>
          <Link className="text-black text-center text-sm font-semibold tracking-[0.14px]" href="/">
            <div className={`logo inline-flex h-[32px] justify-end items-center shrink-0`}>
              <img
                src={'/assets/common/StyleyLogo.png'}
                alt="logo"
                width={90}
                height={14}
                className={`w-[90px] ${activeChatTheme != 'theme5' ? '!invert' : 'brightness-0'} h-[14px] `}
              />
            </div>
          </Link>
        </div>

        {mobileMenu ? (
          <div className="flex gap-3 w-1/3 justify-end">
            <div className="w-10 h-10 flex items-center justify-center" onClick={() => setMobileMenu(false)}>
              <Image
                src={'/assets/common/cross-mobile.svg'}
                width={30}
                height={30}
                className="invert-[1]"
                alt="close"
              />
            </div>
          </div>
        ) : (
          <div className={`items-center w-1/3 justify-end ${isSearchOpen ? '!hidden' : '!flex'}`}>
            {user?.avatar_url ? (
              <>
                <div className="flex items-center gap-3">
                  <ThemeDropDown />
                  <div
                    className="w-10 h-10 flex items-center justify-center text-sm rounded-full mobile-hide"
                    onClick={() => {
                      dispatch(creditModal(true))
                    }}
                  >
                    {' ' + (subscription?.credits ?? 0)}
                  </div>

                  <div className="flex items-center  gap-2 p-[3px]">
                    <AnimatedNavbar
                      duration={500}
                      navbarConfig={[
                        {
                          item: (
                            <div className="flex items-center justify-center w-10 h-10 cursor-pointer">
                              {user?.avatar_url ? (
                                <Image
                                  className="rounded-full object-cover object-top h-10 w-10"
                                  src={user?.avatar_url}
                                  width={40}
                                  height={40}
                                  alt="user avatar"
                                />
                              ) : (
                                <FaUser size={'24px'} className="text-[24px] rounded-full" />
                              )}
                            </div>
                          ),
                          dropdown: <SettingDropdown onClick={() => {}} />,
                        },
                      ]}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="w-10 h-10 flex items-center justify-center">
                <Image
                  src={'/assets/common/hamburger.svg'}
                  width={30}
                  height={30}
                  alt="menu"
                  onClick={() => setMobileMenu(!mobileMenu)}
                />
              </div>
            )}
          </div>
        )}
        {mobileMenu && (
          <div
            className="bg-white fixed left-0 pt-5 w-full top-[50px] rounded-b-2xl flex flex-col justify-between items-center gap-4 z-[9999]"
            style={{ boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.5)' }}
          >
            <div className="inline-flex flex-col justify-center items-center gap-7 mx-auto mb-2.5">
              {pages.map(
                (item, i) =>
                  (!item.authenticated || (item.authenticated && user)) && (
                    <Link key={i} href={item.link} className="text-center text-base font-semibold leading-3">
                      <div onClick={() => setMobileMenu(false)}>{item.name}</div>
                    </Link>
                  )
              )}
            </div>
            <div className="flex justify-between w-full">
              <div
                onClick={async () => {
                  dispatch(toggleAuthModal('sign_in'))
                  setMobileMenu(false)
                }}
                className="bg-white border border-solid border-black rounded-bl-2xl w-1/2 flex items-center justify-center text-center text-xl leading-5 h-[60px] font-bold"
              >
                {t('common.login')}
              </div>
              <div
                onClick={async () => {
                  dispatch(toggleAuthModal('sign_up'))
                  setMobileMenu(false)
                }}
                className="bg-[#000] text-white rounded-br-2xl w-1/2 flex items-center justify-center text-center text-xl leading-5 h-[60px] font-bold"
              >
                {t('common.sign-up')}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default MobileHeader
